<template>
<div class="body1">
 <el-form  :model="form1" :rules="rules"  ref="form1" label-width="100px" class="demo-ruleForm">
  <el-form-item label="企业名称 :" prop="eName" style="font-weight: bold">
    <label >{{form1.eName}}</label>
  </el-form-item>
   <el-divider></el-divider>
   <el-form-item label="统一社会信用代码 :" prop="eCode"  style="font-weight: bold">
    <label >{{form1.eCode}}</label>
  </el-form-item>
   <el-divider></el-divider>
   <el-form-item label="法定代表人 :" prop="jperson"  style="font-weight: bold">
    <label >{{form1.jperson}}</label>
  </el-form-item>
   <el-divider></el-divider>
   <el-form-item label="联系电话 :" prop="tel"  style="font-weight: bold">
    <label >{{form1.tel}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="地址 :" prop="eAddr"  style="font-weight: bold">
    <label >{{form1.eAddr}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="企业英文名 :" prop="enterprise"  style="font-weight: bold">
    <label >{{form1.enterprise}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="企业网址 :" prop="website"  style="font-weight: bold">
    <label >{{form1.website}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="联系邮箱 :" prop="email"  style="font-weight: bold">
    <label >{{form1.email}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="企业介绍 :" prop="introduce"  style="font-weight: bold">
    <label >{{form1.introduce}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="成立时间 :" prop="foundtime"  style="font-weight: bold">
    <label >{{form1.foundtime}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="目前员工数 :" prop="staff"  style="font-weight: bold">
    <label >{{form1.staff}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="所属行业 :" prop="industry"  style="font-weight: bold">
    <label >{{form1.industry}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="企业优势 :" prop="advantage"  style="font-weight: bold">
    <label >{{form1.advantage}}</label>
  </el-form-item>
   <el-divider></el-divider>
    <el-form-item label="企业所有制 :" prop="classify"  style="font-weight: bold">
    <label >{{form1.classify}}</label>
  </el-form-item>
   <el-divider></el-divider>

  <el-form-item>
    <el-button @click="resetForm()">返回</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'creditupdate',
  data () {
    // eslint-disable-next-line no-unused-vars
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('统一社会信用代码不能为空'))
      } else {
        const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的统一社会信用代码'))
        }
      }
    }
    return {
      form1: {},
      rules: {

      }
    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/admini/app/find?id=' + that.$route.query.pid).then(function (response) {
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  },
  methods: {
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    resetForm () { this.$router.push({path: '/creditlist'}) }
  }

}
</script>

<style >
.body1{
  width:600px;
  margin: 0 auto;
}
 .body1    .el-form-item__label{
  width: 140px !important;
}
.body1 .el-form-item__content{
   margin-left: 140px !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/admin/creditupdate.vue